// Copyright (c) 2016 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import {resetConfirmationModal, setConfirmationModal} from './confirmation-modal';
import actions from '../../action-list';
import {addAuditVsrToClaim} from '../../shared/services/claim-vsr-helper';
import {additionalRepair} from './additional-repair';
import {bindActionCreators} from 'redux';
import {confirmationModalMap} from '../services/confirmation-modal-map';
import {copyClaim} from './copy-claim';
import {getClaim} from '../../shared/repositories';
import {readClaimProduct} from './get-product-details';
import {readPipDetails} from './get-pip-details';
import {shouldRunAdditionalAction} from '../../shared/services/claim-shared-helper';
import {updateSelectedAction} from './update-selected-action';

const handleRouteAction = (action, claim, dispatch) => {

    const actionsToBeBound = {
        resetConfirmationModal,
        updateSelectedAction
    };

    const boundActionCreators = bindActionCreators(actionsToBeBound, dispatch);

    const confirmActions = {
        adjust: boundActionCreators.updateSelectedAction.bind(null, action),
        delete: boundActionCreators.updateSelectedAction.bind(null, action),
        pushxml: boundActionCreators.updateSelectedAction.bind(null, action),
        reconcile: boundActionCreators.updateSelectedAction.bind(null, action),
        unreconcile: boundActionCreators.updateSelectedAction.bind(null, action),
        unsubmit: boundActionCreators.updateSelectedAction.bind(null, action)
    };

    const actionMethod = confirmationModalMap(action, boundActionCreators.resetConfirmationModal, confirmActions);

    const map = {
        ADD_REP: additionalRepair,
        COPY_CLAIM: copyClaim,
        DIS_VSR: boundActionCreators.updateSelectedAction.bind(null, action),
        SUB: boundActionCreators.updateSelectedAction.bind(null, action)
    };

    if (['RECONCILE', 'UNRECONCIL', 'DEL', 'REQ_ADDL', 'UNSUB', 'PUSH_XML'].includes(action.id)) {

        dispatch(setConfirmationModal(actionMethod));

    } else {

        map[action.id](claim)(dispatch);

    }

};

/* eslint-disable complexity */

export const readPipClaim = (claimNumber, action) =>

    async (dispatch, getState) => {

        let updatedClaim;

        dispatch(busyCounter.increaseBusyCounter());

        try {

            updatedClaim = await getClaim(claimNumber, 'pip-claims');
            const pipId = `${updatedClaim.pipProgram.pipNumber}-${updatedClaim.pipProgram.internalRecall}`;

            // adds special VSR for claim in audit status

            if (updatedClaim.claimStatus.key === 'ZADT') {

                updatedClaim = addAuditVsrToClaim(updatedClaim);

            }

            dispatch({
                type: actions.SET_CLAIM_PIP,
                updatedClaim
            });

            if (action && shouldRunAdditionalAction(action)) {

                handleRouteAction(action, updatedClaim, dispatch);

            }

            readClaimProduct(updatedClaim.pin)(dispatch, getState);
            readPipDetails(pipId, false)(dispatch, getState);

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };

/* eslint-enable complexity */



// WEBPACK FOOTER //
// ./src/claim/pip/action-creators/get-pip-claim.js